import { render } from "./FormText.vue?vue&type=template&id=b2dce6c2"
import script from "./FormText.vue?vue&type=script&lang=js"
export * from "./FormText.vue?vue&type=script&lang=js"

import "./FormText.vue?vue&type=style&index=0&id=b2dce6c2&lang=css"
script.render = render

export default script